import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";

export default class Logo{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        const tmpl = makeEl('div', _parent, {class: 'footer-logo-wrap'});
        if(this.ds.country === 'KR'){
            tmpl.innerHTML= `
            <a class="footer-logo ncsoft" href="${this.ds.config.companyLink}" target="_blank">NCSOFT</a>
            <a class="footer-logo ncdinos" href="https://www.ncdinos.com/" target="_blank">NC DINOS</a>
            `
        }
        else{
            tmpl.innerHTML= `
            <a class="footer-logo ncsoft" href="${this.ds.config.companyLink}" target="_blank">NCSOFT</a>
            `
        }
    }
}